export const formatRatingInput = (value) => {
  if (value === null || value === undefined || value === "") {
    return "";
  }

  const parsed = Number(value);
  return Number.isFinite(parsed) ? String(Math.round(parsed * 1000) / 1000) : "";
};

export const buildRatingPayload = ({ startingRating }) => {
  if (startingRating === "" || startingRating === null || startingRating === undefined) {
    return {};
  }

  const parsed = Number(startingRating);
  if (!Number.isFinite(parsed)) {
    throw new Error("Manual starting rating must be a number");
  }

  return {
    starting_rating: parsed,
  };
};
